import { FC, ReactNode, createContext, useState } from 'react';

export interface ExperienceContextProps {
  inShortList: boolean;
  handleShortList: (inShortList: boolean) => void;
}

interface ExperienceProviderProps {
  children: ReactNode;
}

const ExperienceContext = createContext<ExperienceContextProps>(
  {} as ExperienceContextProps,
);

export const ExperienceContextProvider: FC<ExperienceProviderProps> = ({
  children,
}) => {
  const [inShortList, setInShortList] = useState(false);

  function handleShortList(inShortList: boolean) {
    setInShortList(inShortList);
  }

  return (
    <ExperienceContext.Provider
      value={{
        inShortList,
        handleShortList,
      }}>
      {children}
    </ExperienceContext.Provider>
  );
};

export default ExperienceContext;
